import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center px-4">
      <div className="max-w-xl w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="mb-8">
          <XCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Checkout Cancelled</h1>
          <p className="text-lg text-gray-600 mb-8">
            Your subscription process was cancelled. No worries - you can try again whenever you're ready!
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block w-full bg-indigo-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition-colors"
          >
            Return to Homepage
          </Link>
          <p className="text-sm text-gray-500">
            Need help? <a href="#contact" className="text-indigo-600 hover:text-indigo-800">Contact our support team</a>
          </p>
        </div>
      </div>
    </div>
  );
}